"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_findindex_1 = __importDefault(require("lodash.findindex"));
var ImagesActionType;
(function (ImagesActionType) {
    ImagesActionType["SHOW_NEXT_IMAGE"] = "images_SHOW_NEXT_IMAGE";
    ImagesActionType["SHOW_PREVIOUS_IMAGE"] = "images_SHOW_PREVIOUS_IMAGE";
    ImagesActionType["SHOW_IMAGE"] = "images_SHOW_IMAGE";
    ImagesActionType["URL_CHANGED"] = "images_URL_CHANGED";
})(ImagesActionType = exports.ImagesActionType || (exports.ImagesActionType = {}));
exports.initialState = {
    shopifyProductId: "",
    images: [],
    featuredImageIndex: 0,
};
exports.reducer = function (oldState, action) {
    if (oldState === void 0) { oldState = exports.initialState; }
    switch (action.type) {
        case ImagesActionType.SHOW_IMAGE: {
            return __assign({}, oldState, { featuredImageIndex: action.imageIndex });
        }
        case ImagesActionType.SHOW_PREVIOUS_IMAGE: {
            var numberOfImages = oldState.images.length;
            var featuredImageIndex = (oldState.featuredImageIndex - 1 + numberOfImages) % numberOfImages;
            return __assign({}, oldState, { featuredImageIndex: featuredImageIndex });
        }
        case ImagesActionType.SHOW_NEXT_IMAGE: {
            var numberOfImages = oldState.images.length;
            var featuredImageIndex = (oldState.featuredImageIndex + 1) % numberOfImages;
            return __assign({}, oldState, { featuredImageIndex: featuredImageIndex });
        }
        case ImagesActionType.URL_CHANGED: {
            var featuredImageIndex = lodash_findindex_1.default(oldState.images, function (image) {
                return image.associatedVariantIds.indexOf(action.variantId) >= 0;
            });
            if (featuredImageIndex >= 0 && !action.measurementsShown) {
                return __assign({}, oldState, { featuredImageIndex: featuredImageIndex });
            }
            return oldState;
        }
        default:
            return oldState;
    }
};
